import type { SyntheticEvent } from 'react';
import type { GoalModalProps } from './AddEditGoalModal';
import { useI18n } from '@whizz/react-i18n';
import { Button } from '../../../../components';
import { GLOBAL_ICONS } from '../../../../util/vars';
import { CancelButtonModal } from '../../../../global';
import { ModalFooter } from '../../../../components/modal/Modal';

const DeleteConfirmModal = ({ toggle, toggleConfirm, data, onSuccess, onError }: GoalModalProps): JSX.Element => {
  const { translate } = useI18n();

  const handleSubmit = (event: SyntheticEvent) => {
    event.preventDefault();

    if (null == data?.goal_key) {
      return;
    }

    onSuccess?.();
    toggleConfirm(false);
  };

  const handleCancel = () => {
    toggleConfirm(false);
    toggle(true);
  };

  const WarningMessage = () =>
    <>
      <span className={'font-bold italic'}>
        {translate('pages.ROSTER_MANAGEMENT.CLASSES.ADD_EDIT.DELETE_HINT_3', { class: data?.name })}
      </span>
      <p>{translate('pages.ROSTER_MANAGEMENT.CLASSES.ADD_EDIT.DELETE_HINT_4')}</p>
    </>;

  const CancelButton = () =>
    <CancelButtonModal
      align={'start'}
      onClick={handleCancel}
    >{translate('pages.ROSTER_MANAGEMENT.CLASSES.ADD_EDIT.BUTTONS.KEEP_CLASS')}</CancelButtonModal>;

  const ConfirmButton = () =>
    <Button
      color={'negative'}
      icon={GLOBAL_ICONS.delete}
      isOutline
      onClick={handleSubmit}
    >{translate('pages.ROSTER_MANAGEMENT.CLASSES.ADD_EDIT.BUTTONS.CONFIRM_DELETION')}</Button>;

  return (
    <form onSubmit={handleSubmit}>
      <div className={'container space-y-6'}>
        <WarningMessage />
      </div>
      <ModalFooter>
        <CancelButton />
        <ConfirmButton />
      </ModalFooter>
    </form>
  );
};

export { DeleteConfirmModal };
